import React, { useEffect, useState, useContext } from 'react';
import { Grid, FormHelperText, CircularProgress, Typography, InputLabel } from '@material-ui/core';
import { SecondaryButton, TextBox } from '../../../../Core/FormInput';
import AppContext from '../../../../App/AppContext';
import { getTCardPriorityByID, postTCardPriority } from '../../../../Core/Service/Tcard-Priority-service';

const UpdatePriorityModal = (props) => {
    const { showToast } = useContext(AppContext);
    const [loading, setLoading] = useState(false);
    const [state, setState] = useState({
        tCardPriorityDescription: '',
        tCardPrioritySequence: '',
        errors: {}
    });

    useEffect(() => {
        const fetchTcardPriority = async () => {
            if (props.priorityID) {
                setLoading(true);
                try {
                    let res = await getTCardPriorityByID(props.priorityID);
                    let data = res?.data?.list?.table[0] || {};
                    if (res.success) {
                        setState((st) => ({
                            ...st,
                            tCardPriorityDescription: data.tCardPriorityDescription,
                            tCardPrioritySequence: data.tCardPrioritySequence,
                            errors: {}
                        }));
                    }
                } finally {
                    setLoading(false);
                }
            }
        };
        fetchTcardPriority();
    }, [props.priorityID]);

    const handleInput = (e) => {
        const { name, value } = e.target;
        setState((st) => ({
            ...st,
            [name]: value,
            errors: { ...st.errors, [name]: '' }
        }));
    };

    const handleValidation = () => {
        let errors = {};
        let formIsValid = true;

        if (!state.tCardPriorityDescription.trim()) {
            formIsValid = false;
            errors.tCardPriorityDescription = 'Description is required.';
        }

        if (state.tCardPrioritySequence === '') {
            formIsValid = false;
            errors.tCardPrioritySequence = 'Sequence is required.';
        }

        setState((st) => ({
            ...st,
            errors: errors
        }));

        return formIsValid;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (handleValidation()) {
            setLoading(true);
            try {
                const data = {
                    tCardPriorityID: props.priorityID || null,
                    tCardPriorityDescription: state.tCardPriorityDescription,
                    tCardPrioritySequence: state.tCardPrioritySequence
                };
                let res = await postTCardPriority(data);
                if (res.data.success) {
                    showToast(`TCard Priority ${props.priorityID ? 'Updated' : 'Added'} successfully`);
                    props.onClose(true);
                } else {
                    console.error(res.message);
                }
            } catch (error) {
                console.error('Error submitting data:', error);
            } finally {
                setLoading(false);
            }
        }
    };

    return (
        <div>
            {loading ? (
                <Grid
                    container
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        minHeight: '200px'
                    }}
                >
                    <CircularProgress />
                    <Typography style={{ fontWeight: 'bold', marginLeft: 10 }}>Loading...</Typography>
                </Grid>
            ) : (
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <InputLabel className="mandatoryfields" required>
                            Description
                        </InputLabel>
                        <TextBox onChange={handleInput} value={state.tCardPriorityDescription} name="tCardPriorityDescription" />
                        {state.errors.tCardPriorityDescription && (
                            <FormHelperText className="mandatoryfields">{state.errors.tCardPriorityDescription}</FormHelperText>
                        )}
                    </Grid>
                    <Grid item xs={12}>
                        <InputLabel className="mandatoryfields" required>
                            Sequence
                        </InputLabel>
                        <TextBox onChange={handleInput} value={state.tCardPrioritySequence} name="tCardPrioritySequence" />
                        {state.errors.tCardPrioritySequence && (
                            <FormHelperText className="mandatoryfields">{state.errors.tCardPrioritySequence}</FormHelperText>
                        )}
                    </Grid>
                    <Grid item xs={12} style={{ marginTop: 20, marginBottom: 15 }}>
                        <SecondaryButton fullWidth onClick={handleSubmit}>
                            Submit
                        </SecondaryButton>
                    </Grid>
                </Grid>
            )}
        </div>
    );
};

export default UpdatePriorityModal;
